export default {
  name: "alerts",
  components: {},
  props: [],
  data() {
    return {
      state: "" // default || success || error
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
